import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { API } from '../api';
import { toast, ToastContainer } from 'react-toastify';

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
  @keyframes fadeSlideIn{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
  @keyframes modalIn{from{opacity:0;transform:scale(0.94) translateY(16px)}to{opacity:1;transform:scale(1) translateY(0)}}
  @keyframes rowIn{from{opacity:0;transform:translateX(-10px)}to{opacity:1;transform:translateX(0)}}
  @keyframes spin{to{transform:rotate(360deg)}}
  @keyframes shimmer{0%{background-position:-600px 0}100%{background-position:600px 0}}
  @keyframes pulse{0%,100%{box-shadow:0 0 0 0 rgba(99,179,237,0.4)}50%{box-shadow:0 0 0 8px rgba(99,179,237,0)}}
  *{box-sizing:border-box}
  .cp-root{font-family:'DM Sans',sans-serif;animation:fadeSlideIn 0.5s ease both}
  .cp-select{width:20%;padding:11px 14px;background:#f8faff;border:1.5px solid #e2e8f5;
    border-radius:12px;color:#1a1d2e;font-size:14px;font-family:'DM Sans',sans-serif;
    outline:none;cursor:pointer;appearance:none;
    background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%2363b3ed' stroke-width='2' fill='none'/%3E%3C/svg%3E");
    background-repeat:no-repeat;background-position:right 14px center;
    transition:border-color 0.2s,box-shadow 0.2s}
  .cp-select:focus{border-color:#63b3ed;box-shadow:0 0 0 3px rgba(99,179,237,0.15)}
  .cp-select:disabled{background:#f0f0f0;color:#a0aec0;cursor:not-allowed}
  .cp-input{width:100%;padding:11px 14px;background:#f8faff;border:1.5px solid #e2e8f5;
    border-radius:12px;color:#1a1d2e;font-size:14px;font-family:'DM Sans',sans-serif;
    outline:none;transition:border-color 0.2s,box-shadow 0.2s,background 0.2s}
  .cp-input:focus{border-color:#63b3ed;background:#fff;box-shadow:0 0 0 3px rgba(99,179,237,0.15)}
  .cp-input::placeholder{color:#a0aec0}
  .cp-input.small{padding:8px 10px;font-size:13px;text-align:center;border-radius:8px}
  .cp-input.small:focus{border-color:#63b3ed;box-shadow:0 0 0 2px rgba(99,179,237,0.15)}
  .cp-btn-primary{padding:12px 26px;background:linear-gradient(135deg,#63b3ed,#4299e1);
    border:none;border-radius:12px;color:#fff;font-size:14px;font-weight:700;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:transform 0.15s,box-shadow 0.15s;
    display:inline-flex;align-items:center;gap:8px}
  .cp-btn-primary:hover{transform:translateY(-2px);box-shadow:0 8px 20px rgba(66,153,225,0.4)}
  .cp-btn-primary:disabled{opacity:0.6;cursor:not-allowed;transform:none}
  .cp-btn-secondary{padding:11px 22px;background:#f0f4ff;border:1.5px solid #e2e8f5;
    border-radius:12px;color:#4a5568;font-size:14px;font-weight:600;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:all 0.15s}
  .cp-btn-secondary:hover{background:#e8eeff;border-color:#63b3ed;color:#3182ce}
  .cp-row:hover td{background:#f0f7ff !important;transition:background 0.15s}
  .action-btn{width:34px;height:34px;border:none;border-radius:9px;cursor:pointer;font-size:15px;
    display:inline-flex;align-items:center;justify-content:center;transition:transform 0.15s,box-shadow 0.15s}
  .action-btn:hover{transform:scale(1.18);box-shadow:0 4px 14px rgba(0,0,0,0.15)}
  .skeleton{background:linear-gradient(90deg,#f0f4ff 25%,#e8eeff 50%,#f0f4ff 75%);
    background-size:600px 100%;animation:shimmer 1.5s infinite;border-radius:6px}
  .nav-item{display:flex;align-items:center;gap:12px;padding-top:11px;padding-bottom:11px;
    padding-left:16px;padding-right:16px;cursor:pointer;border-radius:10px;margin:2px 10px;
    color:#aaa;font-size:14px;transition:all 0.15s;white-space:nowrap}
  .nav-item:hover{background:rgba(255,255,255,0.05);color:#fff}
  .nav-item.active{background:rgba(99,179,237,0.12);color:#63b3ed;border-left:3px solid #63b3ed;padding-left:13px}
  .cp-label{font-size:11px;font-weight:700;color:#718096;text-transform:uppercase;letter-spacing:0.5px;margin-bottom:6px;display:block}
  .badge{padding:4px 12px;border-radius:20px;font-size:12px;font-weight:600;display:inline-block}
  .dur-table{width:100%;border-collapse:collapse;border-radius:12px;overflow:hidden}
  .dur-table th{background:linear-gradient(135deg,#667eea,#764ba2);color:#fff;padding:10px 16px;
    font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;text-align:left}
  .dur-table td{padding:10px 16px;font-size:13px;border-bottom:1px solid #f0f4ff;vertical-align:middle}
  .dur-table tr:last-child td{border-bottom:none}
  .dur-table tr:nth-child(even) td{background:#fafbff}
  .modal-scroll{overflow-y:auto;flex:1;padding:0 28px 20px}
  .modal-scroll::-webkit-scrollbar{width:5px}
  .modal-scroll::-webkit-scrollbar-thumb{background:#cbd5e0;border-radius:3px}
  .sec-div{display:flex;align-items:center;gap:12px;margin:20px 0 14px}
  .sec-div span{font-size:11px;font-weight:700;color:#a0aec0;text-transform:uppercase;letter-spacing:0.6px;white-space:nowrap}
  .sec-div::before,.sec-div::after{content:'';flex:1;height:1px;background:#e8eeff}
  .use-default-row{display:flex;align-items:center;gap:12px;padding:12px 16px;
    background:#f8faff;border:1.5px solid #e2e8f5;border-radius:12px;cursor:pointer;
    transition:all 0.2s;user-select:none}
  .use-default-row:hover{border-color:#63b3ed;background:#ebf8ff}
  .use-default-row.active{border-color:#63b3ed;background:#ebf8ff}
  .chk-box{width:20px;height:20px;border-radius:6px;border:2px solid #cbd5e0;
    display:flex;align-items:center;justify-content:center;flex-shrink:0;
    transition:all 0.18s;background:#fff}
  .chk-box.on{background:#63b3ed;border-color:#63b3ed}
  .chk-box.on::after{content:'✓';color:#fff;font-size:12px;font-weight:800}
`;

export default function ManageNightDelivery() {

  const [data, setData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [editId, setEditId] = useState(null);

  const [form, setForm] = useState({
    start_hour: '00',
    start_min: '00',
    end_hour: '00',
    end_min: '00',
    night_charge: ''
  });

  // Fetch
  const fetchData = () => {
    API.get('/night-delivery').then(res => setData(res.data));
  };

  useEffect(() => { fetchData(); }, []);

  // Submit
  const handleSubmit = async () => {
    const start_time = `${form.start_hour}:${form.start_min}`;
    const end_time = `${form.end_hour}:${form.end_min}`;
  
    try {
      if (editId) {
        await API.put(`/night-delivery/${editId}`, {
          start_time,
          end_time,
          night_charge: form.night_charge
        });
        toast.success("Updated");
      } else {
        await API.post('/night-delivery', {
          start_time,
          end_time,
          night_charge: form.night_charge
        });
        toast.success("Added");
      }
  
      setEditId(null);
      fetchData();
  
    } catch (err) {
      toast.error(err.response?.data?.error);
    }
  };

  // Checkbox select
  const toggleSelect = (id) => {
    setSelected(prev =>
      prev.includes(id)
        ? prev.filter(i => i !== id)
        : [...prev, id]
    );
  };

  // Delete
  const handleDelete = async () => {
    if (selected.length === 0) {
      toast.error("Select at least one");
      return;
    }

    await API.post('/night-delivery/delete', { ids: selected });
    toast.success("Deleted");
    setSelected([]);
    fetchData();
  };

  return (
    <Layout activePage="Night Delivery">
     <style>{STYLES}</style>

      <ToastContainer />

      {/* Top */}
      <div style={S.topbar}>
        <h2>Manage Night Delivery</h2>
      </div>

      {/* FORM */}
      <div style={S.card}>

        <div style={S.grid2}>

          {/* Start */}
          <div style={S.fg}>
            <label style={S.label}>Start Time</label>
            <div style={S.timeRow}>
              <select value={form.start_hour} className='cp-select'
                onChange={e => setForm({...form, start_hour:e.target.value})}>
                {[...Array(24)].map((_,i)=>(
                  <option key={i} value={String(i).padStart(2,'0')}>
                    {String(i).padStart(2,'0')}
                  </option>
                ))}
              </select>

              <select value={form.start_min} className='cp-select'
                onChange={e => setForm({...form, start_min:e.target.value})}>
                {[0,15,30,45].map(m=>(
                  <option key={m} value={String(m).padStart(2,'0')}>
                    {String(m).padStart(2,'0')}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* End */}
          <div style={S.fg}>
            <label style={S.label}>End Time</label>
            <div style={S.timeRow}>
              <select value={form.end_hour} className='cp-select'
                onChange={e => setForm({...form, end_hour:e.target.value})}>
                {[...Array(24)].map((_,i)=>(
                  <option key={i} value={String(i).padStart(2,'0')}>
                    {String(i).padStart(2,'0')}
                  </option>
                ))}
              </select>

              <select value={form.end_min} className='cp-select'
                onChange={e => setForm({...form, end_min:e.target.value})}>
                {[0,15,30,45].map(m=>(
                  <option key={m} value={String(m).padStart(2,'0')}>
                    {String(m).padStart(2,'0')}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Charge */}
          <div style={S.fg}>
            <label style={S.label}>Night Charge</label>
            <input
              value={form.night_charge}
              onChange={e => setForm({...form, night_charge:e.target.value})}
              style={S.input}
            />
          </div>

        </div>

        {/* <button style={S.submitBtn} onClick={handleSubmit}>
          Add
        </button> */}
<button style={S.submitBtn} onClick={handleSubmit}>
  {editId ? "Update" : "Add"}
</button>

      </div>

      {/* TABLE */}
      <div style={S.card}>
        <button style={S.delBtn} onClick={handleDelete}>
          Delete Selected
        </button>

        <table style={S.table}>
          <thead>
            <tr style={S.theadRow}>
            <th style={S.th}>
  <input
    type="checkbox"
    checked={selected.length === data.length && data.length > 0}
    onChange={(e) => {
      if (e.target.checked) {
        setSelected(data.map(item => item.night_id));
      } else {
        setSelected([]);
      }
    }}
  />
</th>
              <th style={S.th}>Start</th>
              <th style={S.th}>End</th>
              <th style={S.th}>Charge</th>
              <th style={S.th}>Action</th>
            </tr>
          </thead>

          <tbody>
            {data.map(row => (
              <tr key={row.night_id}>
                <td style={S.td}>
                  <input
                    type="checkbox"
                    checked={selected.includes(row.night_id)}
                    onChange={() => toggleSelect(row.night_id)}
                  />
                </td>
                <td style={S.td}>{row.night_starttime}</td>
                <td style={S.td}>{row.night_endtime}</td>
                <td style={S.td}>{row.night_charge}</td>
                <td style={{ ...S.td, textAlign:'center' }}><button style={S.editBtn} onClick={() => {
  const [sh, sm] = row.night_starttime.split(':');
  const [eh, em] = row.night_endtime.split(':');

  setForm({
    start_hour: sh,
    start_min: sm,
    end_hour: eh,
    end_min: em,
    night_charge: row.night_charge
  });

  setEditId(row.night_id);
}}>
  Edit
</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </Layout>
  );
}

/* ─── Styles ─── */
const S = {
    root: { display: 'flex', minHeight: '100vh', background: '#f4f6fb', fontFamily: "'DM Sans','Segoe UI',sans-serif" },
  
   
    /* Main */
    main: { flex: 1, padding: '28px 28px 40px', minWidth: 0, transition: 'margin-left 0.25s' },
    topbar: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 },
    title: { margin: 0, fontSize: 26, fontWeight: 800, color: '#1a1d2e', letterSpacing: '-0.5px' },
    subtitle: { margin: '4px 0 0', fontSize: 13, color: '#999' },
    addBtn: { padding: '10px 22px', background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
      color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer',
      fontSize: 14, fontWeight: 700, fontFamily: 'inherit', boxShadow: '0 4px 14px rgba(108,99,255,0.35)' },
  
    /* Filters */
    filterRow: { display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' },
    searchWrap: { display: 'flex', alignItems: 'center', gap: 8, background: '#fff',
      border: '1px solid #e8e8e8', borderRadius: 10, padding: '8px 14px',
      flex: 1, minWidth: 220, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
    searchInput: { border: 'none', outline: 'none', fontSize: 13, flex: 1,
      fontFamily: 'inherit', color: '#333', background: 'transparent' },
    clearBtn: { background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', fontSize: 12, padding: 0 },
    filterSelect: { padding: '9px 14px', border: '1.5px solid #e0e0e0', borderRadius: 10,
      fontSize: 13, fontFamily: 'inherit', color: '#333', outline: 'none',
      background: '#fff', minWidth: 180 },
  
      
    /* Card + Table */
    card: { background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(0,0,0,0.06)', overflow: 'hidden',padding:'20px',marginBottom:'30px' },
    table: { width: '100%', borderCollapse: 'collapse' },
    theadRow: { background: '#fafafa' },
    th: { padding: '12px 14px', fontSize: 11, fontWeight: 700, color: '#999',
      textAlign: 'center', borderBottom: '2px solid #f0f0f0',
      textTransform: 'uppercase', letterSpacing: '0.5px' },
    tr: { transition: 'background 0.12s' },
    td: { padding: '12px 14px', fontSize: 13, color: '#333', borderBottom: '1px solid #f8f8f8', textAlign: 'center' },
    emptyCell: { textAlign: 'center', padding: 40, color: '#bbb', fontSize: 14 },
    noImg: { width: 60, height: 40, background: '#f3f2ff', borderRadius: 6,
      display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 },
  
    /* Chips */
    serial:     { background: '#f3f2ff', color: '#6C63FF', borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 700 },
    nameChip:   { background: '#f0fff6', color: '#1a9e5c', borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 600 },
    groupChip:  { background: '#f0f8ff', color: '#1a6eb5', borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 600 },
    stockChip:  { background: '#fff3f0', color: '#d45700', borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 700 },
    badge:      { borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 600 },
    pctChip:   { borderRadius: 20, padding: '4px 12px', fontSize: 13, fontWeight: 700 },
    /* Action buttons */
    viewBtn: { marginRight: 5, background: '#f0fff6', color: '#1a9e5c',
      border: '1px solid #b8f0d0', padding: '4px 12px',
      borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
    editBtn: { marginRight: 5, background: '#f3f2ff', color: '#6C63FF',
      border: '1px solid #d4d0ff', padding: '4px 12px',
      borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
    delBtn: { background: 'rgb(242, 22, 73)', color: 'rgb(251, 231, 235)', border: '1px solid #ffd0d8',
      padding: '4px 12px', borderRadius: 20, cursor: 'pointer', float:'right',
      fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
  
    /* Pagination */
    pagination: { display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '14px 20px', borderTop: '1px solid #f0f0f0' },
    paginInfo: { fontSize: 12, color: '#999' },
    pgBtn: { padding: '5px 14px', background: '#f3f2ff', color: '#6C63FF',
      border: '1px solid #d4d0ff', borderRadius: 8, cursor: 'pointer',
      fontSize: 12, fontWeight: 600, fontFamily: 'inherit' },
  
    /* Modal */
    overlay: { position: 'fixed', inset: 0, background: 'rgba(10,10,30,0.55)', zIndex: 999,
      display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(2px)' },
    modalBox: { background: '#fff', borderRadius: 20, width: 740, maxWidth: '96vw', maxHeight: '90vh',
      display: 'flex', flexDirection: 'column', boxShadow: '0 24px 60px rgba(0,0,0,0.2)' },
    modalHead: { display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '18px 22px', borderBottom: '1px solid #f0f0f0', flexShrink: 0 },
    modalBody: { padding: '20px 22px', overflowY: 'auto', flex: 1 },
    modalFoot: { display: 'flex', justifyContent: 'flex-end', gap: 10,
      padding: '14px 22px', borderTop: '1px solid #f0f0f0', flexShrink: 0 },
    closeBtn: { background: '#ff6b6b22', border: 'none', color: '#ff6b6b',
      borderRadius: '50%', width: 30, height: 30, cursor: 'pointer', fontWeight: 800, fontSize: 14 },
    cancelBtn: { padding: '9px 20px', background: '#f5f5f5', color: '#666',
      border: 'none', borderRadius: 10, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'inherit' },
    submitBtn: { padding: '9px 22px', background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
      color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer',
      fontSize: 13, fontWeight: 700, fontFamily: 'inherit' },
  
    /* Form */
    section: { fontSize: 11, fontWeight: 800, color: '#6C63FF', textTransform: 'uppercase',
      letterSpacing: '0.8px', margin: '18px 0 10px', paddingBottom: 6,
      borderBottom: '1.5px solid #f3f2ff' },
    grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 },
    grid4: { display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12, marginBottom: 14 },
    fg: { display: 'flex', flexDirection: 'column', gap: 5 },
    label: { fontSize: 12, fontWeight: 600, color: '#555' },
    req: { color: '#ff6b6b' },
    input: { padding: '8px 12px', border: '1.5px solid #e0e0e0', borderRadius: 8,
      fontSize: 13, fontFamily: 'inherit', color: '#333', outline: 'none', width: '100%',
      boxSizing: 'border-box' },
  };
  